import { Time } from "../baseQuantities/time";
import { Acceleration } from "../baseQuantities/acceleration";
import { Velocity } from "../baseQuantities/velocity";
import {
  AppData,
  CalcMode,
  Calculator,
} from "../../interface/functionalityInterface";
import { Length } from "../baseQuantities/length";

const accelerationSpeed: CalcMode = {
  id: "001accelerationSpeed",
  name: "speed",
  baseQuantities: [
    { ...Acceleration },
    { ...Velocity },
    { ...Velocity, name: "initial_velocity", symbol: "v0" },
    { ...Time },
  ],
  equation: "a=(v-v\u2080)/t",
};

const accelerationDistance: CalcMode = {
  id: "001accelerationDistance",
  name: "distance",
  baseQuantities: [
    { ...Acceleration },
    { ...Velocity },
    { ...Time, toolTip: "cannot calculate time" },
    { ...Length, name: "distance", symbol: "s" },
  ],
  equation: "a=v*t+v*t\u00B2/2",
};

export const accelerationCalc: Calculator = {
  type: AppData.CALCULATOR,
  updatedAt: "2022-07-26",
  name: "acceleration",
  branch: "Physics",
  difficulty: "intermediate",
  inputs: [accelerationSpeed, accelerationDistance],
  calculate: [
    {
      name: "speed",

      equations: [
        {
          target: "acceleration",
          expression: "((velocity) - (initial_velocity)) / (time)",
        },
        {
          target: "velocity",
          expression: "(acceleration) * (time) + (initial_velocity)",
        },
        {
          target: "initial_velocity",
          expression: "(velocity) - (acceleration) * (time)",
        },
        {
          target: "time",
          expression: "((velocity) - (acceleration) * (time))",
        },
      ],
    },

    {
      name: "distance",

      equations: [
        {
          target: "acceleration",
          expression: "2 * ((distance) - (velocity) * (time)) / (time) ^ 2",
        },
        {
          target: "velocity",
          expression:
            "((distance) - 0.5 * (acceleration) * (time) ^ 2) / (time)",
        },
        {
          target: "distance",
          expression: "(velocity) * (time) + 0.5 * (acceleration) * (time) ^ 2",
        },
      ],
    },
  ],
};
